/**
 * App.js — top-level component for the Nowhere Charters booking app.
 *
 * Routes (v1, in-progress):
 *   /                  public landing placeholder
 *   /book              booking flow            — PR #9+
 *   /book/:id          confirmation            — PR #9+
 *   /captain/login     captain sign in         — this PR
 *   /captain           captain dashboard       — this PR (skeleton)
 *   /captain/*         future auth-guarded admin views
 *   /terms             terms of service        — later
 *   /privacy           privacy policy          — later
 *
 * The site-wide UnderConstructionBanner renders on public routes only
 * (controlled by the REACT_APP_UNDER_CONSTRUCTION build arg). It is hidden on
 * /captain* so the captain dashboard reads clean for Matt + Michelle.
 */

import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import RequireAuth from './components/RequireAuth';
import UnderConstructionBanner from './UnderConstructionBanner';
import Book from './pages/Book';
import CaptainDashboard from './pages/CaptainDashboard';
import CaptainLogin from './pages/CaptainLogin';
import Landing from './pages/Landing';
import SignWaiver from './pages/SignWaiver';

export default function App() {
  // Public-only banner — keep the captain dashboard and the guest waiver
  // sign page clean (no public "under construction" notice on those).
  const { pathname } = useLocation();
  const hideBanner =
    pathname.startsWith('/captain') || pathname.startsWith('/sign');

  return (
    <>
      {hideBanner ? null : <UnderConstructionBanner />}

      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/book" element={<Book />} />
        <Route path="/sign/:token" element={<SignWaiver />} />
        <Route path="/captain/login" element={<CaptainLogin />} />
        <Route
          path="/captain"
          element={
            <RequireAuth>
              <CaptainDashboard />
            </RequireAuth>
          }
        />
      </Routes>
    </>
  );
}
